<template>
  <DefaultBackground>
    <div
      class="bg-white rounded-lg shadow-card px-4 py-8 sm:p-12 max-w-xl min-w-full sm:min-w-30 mx-auto mt-20"
    >
      <h1 class="font-semibold text-2xl lg:text-3xl text-center mb-10">
        Finish Account Registration
      </h1>

      <div class="sm:grid sm:grid-cols-2 mb-3 sm:gap-5 mt-8">
        <fieldset class="text-left mb-4 sm:mb-0">
          <label for="su_firstName" class="text-sm">First Name</label>
          <input
            type="text"
            class="input mt-2"
            id="su_firstName"
            v-model="firstName"
          />
        </fieldset>
        <fieldset class="text-left">
          <label for="su_lastName" class="text-sm">Last Name</label>
          <input
            type="text"
            class="input mt-2"
            id="su_lastName"
            v-model="lastName"
          />
        </fieldset>
      </div>
      <fieldset class="text-left mb-3">
        <label for="email" class="text-sm">Email</label>
        <input
          type="email"
          :disabled="true"
          class="input mt-2"
          id="email"
          v-model="email"
        />
      </fieldset>
      <fieldset class="text-left mb-3">
        <label for="registerPassword" class="text-sm">Password</label>
        <input
          type="password"
          class="input mt-2"
          id="registerPassword"
          v-model="password"
        />
      </fieldset>
      <div class="text-left mb-4">
        <label for="passwordConfirmation" class="text-sm"
          >Repeat password</label
        >
        <input
          type="password"
          class="input mt-2"
          id="passwordConfirmation"
          v-model="passwordConfirmation"
        />
      </div>

      <transition name="fade">
        <div class="text-canceled text-center text-xs mt-4" v-if="isError">
          {{
            errors.passwordConfirmation
              ? "Please, repeat your password correctly"
              : "\xa0"
          }}
          {{ errors.email ? "Email has already been taken" : "\xa0" }}
          {{ errors.message ? "Email has already been taken" : "\xa0" }}
        </div>
      </transition>

      <!-- StyledButton here -->
      <StyledButton @click="submit" type="primary"> Save </StyledButton>
    </div>
  </DefaultBackground>
</template>

<script>
import DefaultBackground from "../../components/common/layout/DefaultBackground";
import Heading from "../../components/common/Heading";
import StyledButton from "@/components/common/controls/StyledButton";
import ApiV1 from "@/api/api_v1.0";

export default {
  name: "CompleteRegistrationPage",
  components: { Heading, DefaultBackground, StyledButton },
  data() {
    return {
      email: "",
      password: "",
      passwordConfirmation: "",
      firstName: "",
      lastName: "",
      isError: false,
      redirectTo: null
    };
  },
  created() {
    if (this.$route.query["token"]) {
      const data = JSON.parse(atob(this.$route.query["token"]));
      this.email = data.email;
      this.redirectTo = data.redirect ?? '/';
    } else {
      this.$router.push("/");
    }

    if (this.isLoggedIn) {
      this.$store.commit("CLEAR_AUTH_DATA");
    }
  },
  computed: {},
  methods: {
    async submit() {
      const data = {
        email: this.email,
        password: this.password,
        first_name: this.firstName,
        last_name: this.lastName,
        password_confirmation: this.passwordConfirmation,
      };

      const response = await ApiV1.finishAccountRegistration(data);

      await this.$store.commit("SET_AUTH_DATA", {user: response.data.data, token: response.data.token});

      this.showGlobalSuccessMessage('Saved!')

      this.$router.push(this.redirectTo);
    }
  }
};
</script>
